import { useEffect, useState } from 'react';

import ccSheet from '../../../../../assets/winners-sprites/cc-winners.json';
import ccImage from '../../../../../assets/winners-sprites/cc-winners.png';
import scSheet from '../../../../../assets/winners-sprites/sc-winners.json';
import scImage from '../../../../../assets/winners-sprites/sc-winners.png';
import type { LoadedSprite, SpriteSheetData } from '../../../../../components/SpriteAnimation/types';

const EMPTY_SPRITE: LoadedSprite = {
  frames: [],
  image: null,
  ready: false,
  frameCount: 0,
};

// Decodes a TexturePacker spritesheet (sort frame keys, extract rects, decode the
// image) into a LoadedSprite. `onReady` is skipped if the load was cancelled.
function loadSprite(sheet: SpriteSheetData, imageUrl: string, onReady: (sprite: LoadedSprite) => void): () => void {
  let cancelled = false;

  const frames = Object.keys(sheet.frames)
    .sort()
    .map((key) => sheet.frames[key].frame);

  const image = new Image();
  image.onload = () => {
    if (!cancelled) onReady({ frames, image, ready: true, frameCount: frames.length });
  };
  image.onerror = () => {
    if (!cancelled) console.error('Failed to load winners sprite:', imageUrl);
  };
  image.src = imageUrl;

  return () => {
    cancelled = true;
  };
}

// Loads both jackpot coin-burst sprites (sweeps + social) once, so the conveyor
// can share them across all jackpot tiles instead of loading per tile.
export function useWinnerSprites(): { scSprite: LoadedSprite; ccSprite: LoadedSprite } {
  const [scSprite, setScSprite] = useState<LoadedSprite>(EMPTY_SPRITE);
  const [ccSprite, setCcSprite] = useState<LoadedSprite>(EMPTY_SPRITE);

  useEffect(() => {
    const cancelSc = loadSprite(scSheet as SpriteSheetData, scImage, setScSprite);
    const cancelCc = loadSprite(ccSheet as SpriteSheetData, ccImage, setCcSprite);

    return () => {
      cancelSc();
      cancelCc();
    };
  }, []);

  return { scSprite, ccSprite };
}
